
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  name: 'StarRating',
  props: {
    rating: {
      type: Number,
      required: true,
    },
    comment: {
      type: String,
      required: true,
    },
  },
  emits: ['update:rating', 'update:comment', 'submitRating'],
  setup(props, { emit }) {
    const internalRating = ref(props.rating);
    const internalComment = ref(props.comment);
    const hoverRating = ref(0);

    const setRating = (val: number) => {
      internalRating.value = val;
    };
    const submitReview = () => {
      emit('submitRating');
    };

    watch(internalRating, (val) => {
      emit('update:rating', val);
    });

    watch(internalComment, (val) => {
      emit('update:comment', val);
    });

    return {
      internalRating,
      internalComment,
      hoverRating,
      setRating,
      submitReview,
    };
  },
});
